import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faBriefcase,
  faPhone,
  faFileAlt,
  faGlobe,
  faCalendar
} from '@fortawesome/free-solid-svg-icons';
import './ApplicantDetails.css';

const ApplicantDetails = () => {
  const { id } = useParams();
  const [applicant, setApplicant] = useState(null);

  useEffect(() => {
    const fetchApplicant = async () => {
      try {
        const docRef = doc(db, 'applications', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setApplicant(docSnap.data());
        } else {
          console.log('No such document');
        }
      } catch (error) {
        console.error('Error fetching applicant:', error);
      }
    };

    fetchApplicant();
  }, [id]);

  if (!applicant) {
    return <div>Loading...</div>;
  }

  const formattedDate = applicant.date
    ? applicant.date.toDate().toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      })
    : 'N/A';

  return (
    <div className="applicant-details">
      <h2>{applicant.name}</h2>

      <div className="detail-item">
        <FontAwesomeIcon icon={faCalendar} />
        <span>Applied on: {formattedDate}</span>
      </div>

      <div className="detail-item">
        <FontAwesomeIcon icon={faEnvelope} />
        <span>Email: {applicant.email}</span>
      </div>

      <div className="detail-item">
        <FontAwesomeIcon icon={faBriefcase} />
        <span>Job: {applicant.job}</span>
      </div>

      <div className="detail-item">
        <FontAwesomeIcon icon={faPhone} />
        <span>Phone: {applicant.phone}</span>
      </div>

      <div className="detail-item">
        <FontAwesomeIcon icon={faFileAlt} />
        <span>
          CV:{' '}
          <a
            href={applicant.cv}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download CV
          </a>
        </span>
      </div>

      <div className="detail-item">
        <FontAwesomeIcon icon={faGlobe} />
        <span>
          Portfolio:{' '}
          <a
            href={applicant.portfolio}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Portfolio
          </a>
        </span>
      </div>

      <div className="comment">
        <h3>Comment</h3>
        <p>{applicant.comment}</p>
      </div>
    </div>
  );
};

export default ApplicantDetails;
